// @flow
import React from 'react';
import { SPClusterResourceConfigurationsSummaryContainer } from '@streaming-projects/resource-definitions/cluster-resource-definitions/SPClusterResourceConfigurationsSummaryContainer';
import { AccordionsList } from '@presentational/accordions/AccordionsList';
import { PaddedAndRaisedSegment } from '@presentational/PaddedAndRaisedSegment';
import { getAccordianPanelDetailsObject } from '@src/common-utils/utils';
import { SPStreamGovernanceResourcesSummaryContainer } from '@streaming-projects/resource-definitions/stream-governance-resource-definitions/SPStreamGovernanceResourcesSummaryContainer';
import { SPClusterLinkingResourceConfigurationsSummaryContainer } from '@streaming-projects/resource-definitions/cluster-linking-resource-definitions/SPClusterLinkingResourceConfigurationsSummaryContainer';
import { IS_TABLE_FLOW_LIVE } from '@streaming-projects/constants';
import { SPTableFlowResourceConfigurationsSummaryContainer } from '@streaming-projects/resource-definitions/tableflow-resource-definitions/SPTableFlowResourceConfigurationsSummaryContainer';

import { SPFlinkResourceConfigurationsSummaryContainer } from './flink-resource-definitions/SPFlinkResourceConfigurationsSummaryContainer';

export const SPResourceConfigurations = () => {
  const accordionPanels = [
    getAccordianPanelDetailsObject(
      'Cluster Shared Resource Configurations',
      <SPClusterResourceConfigurationsSummaryContainer />
    ),
    getAccordianPanelDetailsObject(
      'Flink Shared Resource Configurations',
      <SPFlinkResourceConfigurationsSummaryContainer />
    ),
    getAccordianPanelDetailsObject(
      'Stream Governance Resource Configurations',
      <SPStreamGovernanceResourcesSummaryContainer />
    ),

    getAccordianPanelDetailsObject(
      'Cluster Linking Resource Configurations',
      <SPClusterLinkingResourceConfigurationsSummaryContainer />
    ),
  ];

  if (IS_TABLE_FLOW_LIVE) {
    accordionPanels.push(
      getAccordianPanelDetailsObject(
        'Tableflow Resource Configurations',
        <SPTableFlowResourceConfigurationsSummaryContainer />
      )
    );
  }

  return (
    <PaddedAndRaisedSegment>
      <AccordionsList
        initiallyAllCollapsed={true}
        panels={accordionPanels}
        showOnlyTitleInCollapsedState={true}
      />
    </PaddedAndRaisedSegment>
  );
};

export default SPResourceConfigurations;
